import { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react';
import API from '../api';
import { useAuth } from './AuthContext';

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [count, setCount] = useState(0);
  const { user } = useAuth();
  const intervalRef = useRef(null);

  const refresh = useCallback(() => {
    if (!user) return;
    API.get('notifications/?lue=false')
      .then((res) => {
        const data = res.data.results || res.data;
        setCount(Array.isArray(data) ? data.length : 0);
      })
      .catch(() => {});
  }, [user]);

  useEffect(() => {
    refresh();
    intervalRef.current = setInterval(refresh, 30000);
    return () => clearInterval(intervalRef.current);
  }, [refresh]);

  return (
    <NotificationContext.Provider value={{ count, refresh }}>
      {children}
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationContext);
}
